import * as React from "react";
import styled, { css } from "../../../styled/index";
import darken from "polished/lib/color/darken";
import { CS } from "../../../styles/index";
import { BaseInputCSS } from "../input/index";

export interface InputBoxProps extends React.InputHTMLAttributes<HTMLDivElement> {
  shadow?: "one" | "two" | "three";
  type?: "button";
  autoHeight?: boolean;
}

const InputBoxComponent = styled("div")<InputBoxProps>`
  ${BaseInputCSS};
  ${(props) => props.shadow ? CS.shadow.light[props.shadow] : ""};
  ${({autoHeight, theme}) => autoHeight ? css`
    height: auto;
    line-height: 1.4;
  ` : ""};
  ${({type, theme}) => type === "button" ? css`
    transition: 0.3s all;
    color: ${(props) => props.theme.colors.text};
    border: 1px solid ${darken(0.12, "white")};
    background: ${darken(0.04, "white")};
    &:hover {
      border: 1px solid ${darken(0.12, "white")};
      background: ${darken(0.12, "white")};
    }
  ` : ""};
  
`;

export class InputBox extends React.PureComponent<InputBoxProps> {
  render() {
    return <InputBoxComponent {...this.props}>{this.props.children}</InputBoxComponent>;
  }
}
